import { fetchHandler } from "@/bapi-client/fetch";
import { Result } from "@/bapi-client/types";
import { BAPI_COMMANDS } from "@/bapi-client/types/commands";
import {
  TermsAndConditionsAcceptResponse,
  TermsAndConditionsGetAllAcceptedResponse,
  TermsAndConditionsGetLatestResponse,
} from "@/bapi-client/types/terms-and-conditions";

export async function getLatestTermsAndConditions(
  customerId: string,
): Promise<Result<TermsAndConditionsGetLatestResponse>> {
  const response = await fetchHandler(
    BAPI_COMMANDS.TERMS_AND_CONDITIONS_GET_LATEST_TERMS_AND_CONDITIONS,
    "GET",
    `/terms_and_conditions/${customerId}`,
  );
  if (!response.success) return response;
  const parsed = await response.data.json();

  return parsed;
}

export async function getAllAcceptedTermsAndConditions(
  customerId: string,
): Promise<Result<TermsAndConditionsGetAllAcceptedResponse>> {
  const response = await fetchHandler(
    BAPI_COMMANDS.TERMS_AND_CONDITIONS_GET_ALL_ACCEPTED_TERMS_AND_CONDITIONS,
    "GET",
    `/terms_and_conditions/accepted/${customerId}`,
  );
  if (!response.success) return response;
  const parsed = await response.data.json();

  return parsed;
}

export async function acceptTermsAndConditions(
  termsAndConditionsId: string,
): Promise<Result<TermsAndConditionsAcceptResponse>> {
  const response = await fetchHandler(
    BAPI_COMMANDS.TERMS_AND_CONDITIONS_ACCEPT_TERMS_AND_CONDITIONS,
    "POST",
    `/terms_and_conditions/accept/${termsAndConditionsId}`,
    {
      body: {
        accepted: true,
      },
    },
  );
  if (!response.success) return response;
  const parsed = await response.data.json();

  return parsed;
}
